<template>
  <Gauge
    :score="score"
    :item-id="itemId"
    :title="title"
    :request-status="requestStatus"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import Gauge from '@/components/cards/models/Gauge';
import { mapActions } from 'vuex';
import sentimentModel from '@/mixins/sentiment-model';
import { OPERATION } from '@/services/charts-service';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import sacListeningModel from '@/mixins/sac-listening-model';

export default {
  name: 'BrandHealthOwnedEarned',
  components: {
    Gauge,
  },
  mixins: [
    sentimentModel,
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
    ownerPosts: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      score: { value: 0 },
      requestStatus: 'loading',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.LISTENING,
        }),
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.SAC,
        })];

      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        const score = this.getScore(responseListening, responseSac);
        this.score = { value: score };
        this.requestStatus = 'success';
      }).catch(() => {
        this.requestStatus = 'error';
      });
    },
    getScore(responseListening, responseSac) {
      const percente_value = 100;
      const positiveValues = responseListening.general_sentiment.positive_value + responseSac.general_sentiment.positive_value;
      const neutralValues = responseListening.general_sentiment.neutral_value + responseSac.general_sentiment.neutral_value;
      const total = responseListening.collected_mentions + responseSac.collected_mentions;
      const score = (positiveValues + neutralValues) / total;
      if (score) {
        return score * percente_value;
      }
      return 0;
    },
  },
};
</script>

